import React from "react";

export const NoPriceBuildingSignForm = React.forwardRef((props, ref) => {
  const getPageMargins = () => {
    return `
    @page {
        margin: 20px;
        size: 11in 8.5in;
    }

    @media print {
        .top-section, .bottom-section {
            page-break-inside: avoid;
        }
        
        .no-print {
            display: none;
        }
    }

    .print-form-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        padding: 50px;
        border: 1px solid black;
        font-family: Arial, sans-serif;
    }

    .title-text {
        font-size: 55pt;
        text-align: center;
        font-weight: bold;
        margin-top: 25px;
        margin-bottom: 50px;
    }

    .subtitle-text {
        font-size: 40pt;
        text-align: center;
        font-weight: bold;
        width: 75%;
    }

    .asterisk-text {
        font-size: 20pt;
        text-align: center;
        font-style: italic;
        margin-top: 100px;
    }

    `;
  };

  return (
    <>
      <style>{getPageMargins()}</style>
      <div ref={ref} className="print-form-box">
        <p className="title-text">MULTIPLE PURCHASING OPTIONS</p>
        <p className="subtitle-text">0% Financing, Cash, or Rent-To-Own*</p>
        <p className="asterisk-text">
          * Rent-to-own is not available on Animal Structures or Cantina
        </p>
      </div>
    </>
  );
});

export default NoPriceBuildingSignForm;
